import { useMediaQuery } from 'react-responsive';

const OnlyShowOnDesktop = ({ children }) => {
  const isDesktop = useMediaQuery({ query: '(min-width: 768px)' });
  return <>{isDesktop && children}</>;
};

export default OnlyShowOnDesktop;
